import { memo } from 'react'
import * as Styled from '../styled'
import { TMediaItemType } from 'types/media'
import { imageTypes, videoTypes } from 'consts'
import { calculateShownVideoFrames } from './utils'
import { useGetThumbLoad } from './useGetThumbLoad'

interface IThumbnailContentProps {
  type: TMediaItemType
  thumbnail: string | null
  videoThumbnailWidth: number
  videoThumbnailLeft: number
  frames: string[]
  frameSpacing: number
  pixelsPerSecond: number
}

export const ThumbnailContent = memo(
  ({
    type,
    thumbnail,
    videoThumbnailWidth,
    videoThumbnailLeft,
    frames,
    frameSpacing,
    pixelsPerSecond
  }: IThumbnailContentProps) => {
    const isVideoThumb = videoTypes.includes(type) && frames.length > 0
    const isImageThumb = imageTypes.includes(type) && Boolean(thumbnail)

    const isThumbLoading = useGetThumbLoad(isImageThumb ? thumbnail : null)

    const shownFrames = calculateShownVideoFrames(
      frames,
      videoThumbnailWidth,
      pixelsPerSecond,
      frameSpacing
    )

    if (isVideoThumb) {
      return (
        <Styled.VideoThumbnail
          $width={videoThumbnailWidth}
          $left={videoThumbnailLeft}
        >
          {shownFrames.map((frame, index) => (
            <Styled.VideoFrame
              // eslint-disable-next-line react/no-array-index-key
              key={`${frame}-${index}`}
              style={{
                backgroundImage: `url(${frame})`,
                width: pixelsPerSecond * frameSpacing
              }}
            />
          ))}
        </Styled.VideoThumbnail>
      )
    }

    if (isImageThumb) {
      return (
        <>
          {isThumbLoading && <Styled.ThumbnailSkeletonBg />}
          <Styled.Thumbnail
            $bgImageUrl={thumbnail!}
            $isThumbLoading={isThumbLoading}
          />
        </>
      )
    }

    return <Styled.ThumbnailSkeletonBg />
  }
)

ThumbnailContent.displayName = 'ThumbnailContent'
